
import Pagination from './Pagination.vue'
export default {
  components: {
    Pagination
  },
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    lastPage: {
      type: Number,
      required: true
    },
    firstPage: {
      type: Number,
      required: true
    },
    pageRange: {
      type: Number,
      required: true
    },
    hrefBody: {
      type: String,
      required: true
    }
  },
  emits: {
    'page-selected' (payload: number) {
      return payload
    }
  },
  methods: {
    getHref (page: number) {
      // @ts-ignore
      return `${this.hrefBody}?page=${page}`
    },
    pageSelectedHandler (page: number) {
      // @ts-ignore
      this.$emit('page-selected', page)
    }
  }

}
